"use strict";
// automatically generated by the FlatBuffers compiler, do not modify
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.UserHeightRecordingStatusResponseT = exports.UserHeightRecordingStatusResponse = void 0;
const flatbuffers = __importStar(require("flatbuffers"));
const user_height_calibration_status_js_1 = require("../../solarxr-protocol/rpc/user-height-calibration-status.js");
class UserHeightRecordingStatusResponse {
    constructor() {
        this.bb = null;
        this.bb_pos = 0;
    }
    __init(i, bb) {
        this.bb_pos = i;
        this.bb = bb;
        return this;
    }
    static getRootAsUserHeightRecordingStatusResponse(bb, obj) {
        return (obj || new UserHeightRecordingStatusResponse()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
    }
    static getSizePrefixedRootAsUserHeightRecordingStatusResponse(bb, obj) {
        bb.setPosition(bb.position() + flatbuffers.SIZE_PREFIX_LENGTH);
        return (obj || new UserHeightRecordingStatusResponse()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
    }
    hmdHeight() {
        const offset = this.bb.__offset(this.bb_pos, 4);
        return offset ? this.bb.readFloat32(this.bb_pos + offset) : 0.0;
    }
    status() {
        const offset = this.bb.__offset(this.bb_pos, 6);
        return offset ? this.bb.readUint8(this.bb_pos + offset) : user_height_calibration_status_js_1.UserHeightCalibrationStatus.NONE;
    }
    static startUserHeightRecordingStatusResponse(builder) {
        builder.startObject(2);
    }
    static addHmdHeight(builder, hmdHeight) {
        builder.addFieldFloat32(0, hmdHeight, 0.0);
    }
    static addStatus(builder, status) {
        builder.addFieldInt8(1, status, user_height_calibration_status_js_1.UserHeightCalibrationStatus.NONE);
    }
    static endUserHeightRecordingStatusResponse(builder) {
        const offset = builder.endObject();
        return offset;
    }
    static createUserHeightRecordingStatusResponse(builder, hmdHeight, status) {
        UserHeightRecordingStatusResponse.startUserHeightRecordingStatusResponse(builder);
        UserHeightRecordingStatusResponse.addHmdHeight(builder, hmdHeight);
        UserHeightRecordingStatusResponse.addStatus(builder, status);
        return UserHeightRecordingStatusResponse.endUserHeightRecordingStatusResponse(builder);
    }
    unpack() {
        return new UserHeightRecordingStatusResponseT(this.hmdHeight(), this.status());
    }
    unpackTo(_o) {
        _o.hmdHeight = this.hmdHeight();
        _o.status = this.status();
    }
}
exports.UserHeightRecordingStatusResponse = UserHeightRecordingStatusResponse;
class UserHeightRecordingStatusResponseT {
    constructor(hmdHeight = 0.0, status = user_height_calibration_status_js_1.UserHeightCalibrationStatus.NONE) {
        this.hmdHeight = hmdHeight;
        this.status = status;
    }
    pack(builder) {
        return UserHeightRecordingStatusResponse.createUserHeightRecordingStatusResponse(builder, this.hmdHeight, this.status);
    }
}
exports.UserHeightRecordingStatusResponseT = UserHeightRecordingStatusResponseT;
